export const services = [
  {
    title: '24 Saat Güvenlik',
    id: 16,
    selected: false
  },
  {
    title: 'Kamera Sistemi',
    id: 17,
    selected: false
  },
  {
    title: 'Lig TV',
    id: 18,
    selected: false
  },
  {
    title: 'Mutfak',
    id: 20,
    selected: false
  },
  {
    title: 'Ücretsiz Servis',
    id: 21,
    selected: false
  },
  {
    title: 'Sabah Kahvaltısı',
    id: 26,
    selected: false
  },
  {
    title: 'Akşam Yemeği',
    id: 27,
    selected: false
  },
  {
    title: 'Günlük Temizlik',
    id: 28,
    selected: false
  },
  {
    title: 'Haftalık Temizlik',
    id: 29,
    selected: false
  }
]

export const roomFeatures = [
  {
    title: 'Balkonlu Oda',
    id: 5,
    selected: false
  },
  {
    title: 'Mini Buzdolabı',
    id: 9,
    selected: false
  },
  {
    title: 'Klima',
    id: 10,
    selected: false
  },
  {
    title: 'Duş ve Wc',
    id: 11,
    selected: false
  },
  {
    title: 'TV ve Uydu Yayını',
    id: 12,
    selected: false
  },
  {
    title: 'Sınırsız İnternet',
    id: 13,
    selected: false
  },
  {
    title: 'Kişisel Dolap',
    id: 22,
    selected: false
  },
  {
    title: 'Çalışma Masası',
    value: 23,
    selected: false
  },
  {
    title: 'Oda Telefonu',
    id: 30,
    selected: false
  }
]

export const buildFeatures = [
  {
    title: 'Çamaşır ve Ütü Odası',
    id: 1,
    selected: false
  },
  {
    title: 'Etüt Odası',
    id: 2,
    selected: false
  },
  {
    title: 'Asansör',
    id: 3,
    selected: false
  },
  {
    title: 'Kafeterya',
    id: 4,
    selected: false
  },
  {
    title: 'Çizim Odası',
    id: 6,
    selected: false
  },
  {
    title: 'Spor Salonu',
    id: 8,
    selected: false
  },
  {
    title: 'Hobi ve Oyun Odası',
    id: 19,
    selected: false
  }
]
